import { render, staticRenderFns } from "./SettingsTeam.vue?vue&type=template&id=33ba8adc&scoped=true"
import script from "./SettingsTeam.vue?vue&type=script&lang=js"
export * from "./SettingsTeam.vue?vue&type=script&lang=js"
import style0 from "./SettingsTeam.vue?vue&type=style&index=0&id=33ba8adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ba8adc",
  null
  
)

export default component.exports